import { render, staticRenderFns } from "./cell.vue?vue&type=template&id=1856b68e&scoped=true&"
import script from "./cell.vue?vue&type=script&lang=js&"
export * from "./cell.vue?vue&type=script&lang=js&"
import style0 from "./cell.vue?vue&type=style&index=0&id=1856b68e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1856b68e",
  null
  
)

export default component.exports